import { Component, OnInit } from '@angular/core';
import { AppConfigService } from 'src/app/config/app-config.service';

@Component({
  selector: 'bom-mobile-page',
  templateUrl: './mobile-page.component.html',
  styleUrls: ['./mobile-page.component.scss'],
})
export class MobilePageComponent implements OnInit {
  publicWebUrl: string;

  constructor(private appConfigService: AppConfigService) {}

  ngOnInit(): void {
    const appConfig = this.appConfigService.getConfig();
    this.publicWebUrl = appConfig.linkToPublicWebUrl;
  }
}
